let baseTitle: string = document.querySelector('title')?.textContent || process.env.REACT_APP_TITLE || '';

export const getBaseTitle = () => baseTitle;

export const setBaseTitle = (newTitle: string) => {
  document.title = newTitle;
  baseTitle = newTitle;
};
